import * as React from "react"
import * as styles from "@/features/chat/sections/HowItWorks/howItWorks.module.scss"
import { StepData } from "@shared/uiNew/chat/data"

interface TabsProps {
  steps: StepData[]
  current: number
  onTabClick: (index: number) => void
  tabRefs: React.MutableRefObject<(HTMLButtonElement | null)[]>
}

const Tabs: React.FC<TabsProps> = ({ steps, current, onTabClick, tabRefs }) => {
  return (
    <div className={styles.tabsWrapper}>
      <div className={styles.tabs} role="tablist">
        {steps.map((step, index) => (
          <button
            key={step.id}
            role="tab"
            aria-selected={current === index}
            tabIndex={current === index ? 0 : -1}
            onClick={() => onTabClick(index)}
            className={`${styles.tab} ${current === index ? styles.active : ""}`}
            ref={(el) => {
              tabRefs.current[index] = el
            }}
          >
            {step.label}
          </button>
        ))}
      </div>
    </div>
  )
}

export default Tabs
